/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum SessionFlags {
  NATIVE_HOOK_FAILURE = 0,
  PREVIEW_MODE = 1,
}
